"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BoundaryNodeRule = _interopRequireDefault(require("../algorithm/BoundaryNodeRule"));

var _GeometryGraph = _interopRequireDefault(require("../geomgraph/GeometryGraph"));

var _RobustLineIntersector = _interopRequireDefault(require("../algorithm/RobustLineIntersector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeometryGraphOperation =
/*#__PURE__*/
function () {
  function GeometryGraphOperation() {
    _classCallCheck(this, GeometryGraphOperation);

    GeometryGraphOperation.constructor_.apply(this, arguments);
  }

  _createClass(GeometryGraphOperation, [{
    key: "getArgGeometry",
    value: function getArgGeometry(i) {
      return this._arg[i].getGeometry();
    }
  }, {
    key: "setComputationPrecision",
    value: function setComputationPrecision(pm) {
      this._resultPrecisionModel = pm;

      this._li.setPrecisionModel(this._resultPrecisionModel);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryGraphOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return GeometryGraphOperation;
}();

exports.default = GeometryGraphOperation;

GeometryGraphOperation.constructor_ = function () {
  this._li = new _RobustLineIntersector.default();
  this._resultPrecisionModel = null;
  this._arg = null;

  if (arguments.length === 1) {
    var g0 = arguments[0];
    this.setComputationPrecision(g0.getPrecisionModel());
    this._arg = new Array(1).fill(null);
    this._arg[0] = new _GeometryGraph.default(0, g0);
    ;
  } else if (arguments.length === 2) {
    var _g = arguments[0],
        g1 = arguments[1];
    GeometryGraphOperation.constructor_.call(this, _g, g1, _BoundaryNodeRule.default.OGC_SFS_BOUNDARY_RULE);
  } else if (arguments.length === 3) {
    var _g2 = arguments[0],
        _g3 = arguments[1],
        boundaryNodeRule = arguments[2];
    if (_g2.getPrecisionModel().compareTo(_g3.getPrecisionModel()) >= 0) this.setComputationPrecision(_g2.getPrecisionModel());else this.setComputationPrecision(_g3.getPrecisionModel());
    this._arg = new Array(2).fill(null);
    this._arg[0] = new _GeometryGraph.default(0, _g2, boundaryNodeRule);
    this._arg[1] = new _GeometryGraph.default(1, _g3, boundaryNodeRule);
  }
};